import { Box } from '@mui/material';
import { PanelLogin } from 'src/components/PanelLogin';
import { useAuthContext } from 'src/context/AuthContextProvider';

import AssetComposition from './AssetComposition';
import AssetData from './AssetData';
import AssetPortfolio from './AssetPortfolio';

export default function OperationFIAGROAsset({ hash }: { hash: string }) {
  const { auth } = useAuthContext();

  const showPanelLogin =
    !auth?.user?.subscription?.plan?.permissions?.operacoes_fiagro_ativo ||
    !auth?.isLoggedIn;

  if (showPanelLogin) {
    return (
      <Box p={2}>
        <Box>
          <PanelLogin small={undefined} message={undefined} />
        </Box>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <AssetData hash={hash} />
      <AssetPortfolio hash={hash} />
      <AssetComposition hash={hash} />
    </Box>
  );
}
